import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-marketing-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './marketing-file-manager.component.html',
  styleUrl: './marketing-file-manager.component.scss'
})
export class MarketingFileManagerComponent {
  initialPath: string = 'marketing';
}
